/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { InputArrayData, InputTextArea, InputText, InputSelect, InputNumber } from "../../../../components/input";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { MailService } from "../../../../services/mail/mail.service";
import { codeProcessRequestTypes } from "../../info-technology-process/code-process/codeRequestType";
import { UserSelect } from "../../../../components/input/select/UserSelect";

import { getEnv, isDev } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";

import { Col, Row } from "react-bootstrap";
import { department, unitDN, unitNB, unitTSN } from "../../info-technology-process/data";
import {
  getDDMMYYYFormat,
  getDay,
  getDiffDay,
  getHHmmFormat,
  getLocalDate,
  setUtcTime,
} from "../../../../helper/dateTimeHelper";
// import { VehicleContentForm, VehicleContentStructure } from "./form";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { BusinessTicketContentForm, BusinessTicketContentStructure } from "./formBusinessTicket";
import { validatePhoneNumber, validateRequests } from "../../../../services/util";
import { BusinessTicketRequestService } from "../../../../services/company-office/BusinessTicketService";
import { Upload } from "../../upload";
import { InputDateTimeAntd } from "../../../../components/input/date-time-antd";
import { eTicketOptions, ticketTypeRequest } from "../companyRequestContants/companyRequestContants";
import { InputSelectTag } from "../../../../components/input/select-tag";
import { eApproveTitleCode } from "../../../../constants/bizTitle";
import { useBusinessTicketsRequests } from "./hooks";

const siteUrl = getEnv("REACT_APP_APPROVER_BUSINESS_TICKET_REQUEST_URL");

export const createBusinessTicket: FC = withProcedureWraper(() => {
  const history = useHistory();
  const params = useRouteMatch().params as any;
  const id = +params.id;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  // set State input field
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);

  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState("");
  const [requestType, setRequestType] = useState(codeProcessRequestTypes[0].value);
  const [ticketType, setTicketType] = useState(ticketTypeRequest[0].value as any);
  const [pickedUserName, setPickedUserName] = useState(null as any);
  const [itLead, setItLead] = useState("");
  const [beforeRequestSelected, setBeforeRequestSelected] = useState(null as any);
  const { businessTicketsMyRequests } = useBusinessTicketsRequests();
  const [contentData, setContentData] = useState<any>([]);

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "type",
        label: "Nhu cầu",
      },
      {
        name: "beforeRequest",
        label: "Yêu cầu đã cấp trước đó",
      },
      {
        name: "deparment",
        label: "Cơ quan/ Đơn vị",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "phoneNumber",
        label: "SĐT liên hệ",
      },
      {
        name: "startDate",
        label: "Thời gian bắt đầu",
      },
      {
        name: "endDate",
        label: "Thời gian kết thúc",
      },
      {
        name: "tripItineraty",
        label: "Hành trình",
      },
      {
        name: "description",
        label: "Nội dung",
      },
      {
        name: "requests",
        label: "Yêu cầu đặt chỗ",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
      {
        name: "destinationBusiness",
        label: "Nơi đến công tác",
      },
      {
        name: "baseOnDecision",
        label: "Căn cứ theo quyết định số",
      },
      {
        name: "baseOnProposal",
        label: "Căn cứ theo tờ trình",
      },
      {
        name: "pickApprover",
        label: "Người duyệt",
      },
      {
        name: "findApprover",
        label: "Người duyệt thay thế",
      },
      {
        name: "pickItLead",
        label: "Bộ phận hành chính VPCT",
      },
    ],
    onSubmit: async (payload) => {
      const {
        // requests,
        fileRequests,
        phoneNumber,
        destinationBusiness,
        tripItineraty,
        description,
        baseOnDecision,
        baseOnProposal,
      } = payload;
      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const itleadTmp = employees.find((f: any) => f.eMail === itLead);

      const software: any = softwares.find((f: any) => f.eSystemCode === "TKR");

      // if (!selectedDepartment || !selectedUnit) {
      //   CreateNotification({ title: "Thông báo", body: "Vui lòng chọn CQ/ĐV!", icon: "/icons/warning.png" });
      //   return;
      // }

      if (!phoneNumber) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng nhập SĐT liên hệ!", icon: "/icons/warning.png" });
        return;
      }

      const formattedValue = phoneNumber.toString().padStart(10, "0");

      if (!validatePhoneNumber(formattedValue)) {
        CreateNotification({ title: "Thông báo", body: "Số điện thoại không hợp lệ!", icon: "/icons/warning.png" });
        return;
      }

      if (contentData.length === 0 && id === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (contentData.length) {
        const isValidateAllRequests = validateRequests(contentData);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Yêu cầu đặt chỗ chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (contentData.length > 0) {
        if (ticketType === "refund") {
          let count = 0;
          contentData.forEach((e: any) => {
            if (!e.TickNumber) count++;
          });
          if (count > 0) {
            CreateNotification({ title: "Thông báo", body: "Vui lòng Bổ sung số vé!", icon: "/icons/warning.png" });
            return;
          }
        }
      }

      if (!approver && id === 0) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng chọn thủ trưởng CQ/ĐV!", icon: "/icons/warning.png" });
        return;
      }

      if (!startDate || !endDate) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu",
          icon: "/icons/warning.png",
        });
        return;
      }

      if ((!destinationBusiness || !description) && ticketType !== "passport") {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu",
          icon: "/icons/warning.png",
        });
        return;
      }

      if ((!description || !tripItineraty) && ticketType !== "refund") {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu",
          icon: "/icons/warning.png",
        });
        return;
      }

      const assignees = software.eITStaff;
      const officialVehicleRequest: any =
        id === 0
          ? {
              fields: {
                Title: `Cấp vé công tác`,
                eApprovedBy: approverTmp
                  ? `${approverTmp.eMail}|${approverTmp.Title}`
                  : `${approver}|${pickedUserName}`,
                eApprovedByITLead: itleadTmp
                  ? `${itleadTmp.eMail}|${itleadTmp.Title}`
                  : `${software.eITTeamLead}|${software.eTeamLeadName}`,
                eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
                eAssignee: assignees,
                eOffice: destinationBusiness,
                eWorkingTime: setUtcTime(getDay(startDate)),
                eFinishTime: setUtcTime(getDay(endDate)),
                eBaseOnDecision: baseOnDecision,
                eBaseOnProposal: baseOnProposal?.length > 0 ? JSON.stringify(baseOnProposal) : null,
                eTrip: tripItineraty,
                eTicketType: ticketType,
                eDescription: description,
                eRequestStatus: requestStatus.submitted,
                eRequestType: requestType,
                eContent: JSON.stringify(contentData),
                eFileContent: JSON.stringify(fileRequests),
                eDepartment: id === 0 ? selectedDepartment.value : selectedDepartment,
                eUnit: id === 0 ? selectedUnit.value : selectedUnit,
                ePhoneNumber: formattedValue,
              },
            }
          : {
              fields: {
                Title: `Cấp vé công tác`,
                // eApprovedBy: approverTmp? `${approverTmp.eMail}|${approverTmp.Title}`: `${approver}|${pickedUserName}`,
                // eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
                // eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`,
                // eAssignee: assignees,
                eOffice: destinationBusiness,
                eWorkingTime: setUtcTime(getDay(startDate)),
                eFinishTime: setUtcTime(getDay(endDate)),
                eBaseOnDecision: baseOnDecision,
                eBaseOnProposal: baseOnProposal?.length > 0 ? JSON.stringify(baseOnProposal) : null,
                eTrip: tripItineraty,
                eTicketType: ticketType,
                eDescription: description,
                // eRequestStatus: requestStatus.submitted,
                // eRequestType: requestType,
                eContent: JSON.stringify(contentData),
                eFileContent: JSON.stringify(fileRequests),
                ePhoneNumber: formattedValue,
              },
            };
      addVehicleRequest(officialVehicleRequest);
    },
  });

  const sendMail = async (approver: any, vehicleRequest: any) => {
    const url = siteUrl + "/details/" + vehicleRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "BTRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", vehicleRequest.createdBy.user.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(vehicleRequest.createdDateTime)} - ${getHHmmFormat(vehicleRequest.createdDateTime)}`,
      )
      .replace(mailRegexs.siteUrl, url);

    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };
  const addVehicleRequest = (officialVehicleRequest: any) => {
    if (id != 0) {
      BusinessTicketRequestService.updateBusinessTicketRequest(id, officialVehicleRequest.fields).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.procedureCollaborateTicketDetailPage.path.replace(":id", id));
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Chỉnh sửa yêu cầu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    } else {
      BusinessTicketRequestService.addBusinessTicketRequest(officialVehicleRequest).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Tạo yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          if (officialVehicleRequest.fields.eApprovedBy) {
            sendMail(officialVehicleRequest.fields.eApprovedBy, res);
          }
          history.replace(Routes.procedureCollaborateTicketDetailPage.path.replace(":id", res.id));
        },
        (error) => {
          CreateNotification({
            title: "Thất bại",
            body: `Tạo yêu cầu thất bại.`,
            icon: "/icons/error.png",
          });
          console.log(error);
        },
      );
    }
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onItLeadChange = (selectedOptions: any) => {
    setItLead(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
    setPickedUserName(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].displayName.toLowerCase()
        : null,
    );
  };

  const getApproverOptions = () => {
    let approvers: any = [];
    if (selectedDepartment && selectedDepartment.id > 0 && selectedUnit) {
      approvers = employees
        .filter((f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedUnit.id)
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));

      if (selectedDepartment.id === 1) {
        const tsnHead = isDev
          ? [
              {
                label: "Phạm Phú Yên",
                value: "canbo1@viags.vn",
                default: true,
              },
            ]
          : [
              {
                label: "Phạm Phú Yên",
                value: "yenpp@viags.vn",
                default: true,
              },
              {
                label: "Nguyễn Vĩnh Hưng",
                value: "hungnv@viags.vn",
                default: true,
              },
            ];
        approvers = [...tsnHead];
      }
    } else if (selectedDepartment && selectedDepartment.id != 0)
      approvers = employees
        .filter(
          (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedDepartment.id,
        )
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
    setApproverOptions(approvers);
    // const defaultApprover = approvers.find((a: any) => a.default);
    // setApprover(defaultApprover.value || approvers[0].value);
  };

  const onTicketTypeChange = (selectedOptions: any) => {
    setTicketType(selectedOptions);
    setContentData([]);
    setBeforeRequestSelected(null);
  };

  const onDepartmentChange = (selectedOptions: any) => {
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    if (selectedOptions && typeof selectedOptions.id === "string") setSelectedUnit(selectedOptions);
    setApprover("");
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
  };

  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedDepartment) {
      let id = selectedDepartment.id;
      switch (id) {
        case id === 1:
          break;
      }
    }
  }, [selectedDepartment]);

  const onStartDateChange = (date: any) => {
    const newDate = new Date(date);
    setStartDate(newDate);
    setEndDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(startDate)));
    if (days < 0) {
      setStartDate(newDate);
    }
  };

  const onEndDateChange = (date: any) => {
    const newDate = new Date(date);
    setEndDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(endDate)));
    if (days < 0) {
      setEndDate(newDate);
    }
  };

  const handleBeforeRequestChange = (e: any) => {
    const {
      eDescription,
      eOffice,
      eApprovedBy,
      // eSoftwareId,
      eRequestType,
      eContent,
      // eTicketType,
      eFileContent,
      ePhoneNumber,
      eTrip,
      eWorkingTime,
      eFinishTime,
      eBaseOnDecision,
      eBaseOnProposal,
    } = e.value;
    const approverEmail = eApprovedBy.split("|")[0];
    setValues({
      description: eDescription,
      requests: JSON.parse(eContent),
      fileRequests: JSON.parse(eFileContent),
      phoneNumber: ePhoneNumber,
      destinationBusiness: eOffice,
      tripItineraty: eTrip,
      startDate: eWorkingTime,
      endDate: eFinishTime,
      baseOnDecision: eBaseOnDecision,
      baseOnProposal: eBaseOnProposal ? JSON.parse(eBaseOnProposal) : [],
    });
    setApprover(approverEmail);
    // setSoftwareSelected(eSoftwareId);
    setBeforeRequestSelected(e.value);
    setRequestType(eRequestType);
    setContentData(JSON.parse(eContent));
    setStartDate(new Date(eWorkingTime));
    setEndDate(new Date(eFinishTime));
    // setTicketType(eTicketType);
  };

  useEffect(() => {
    if (id !== 0) {
      BusinessTicketRequestService.getBusinessTicketRequest(id)
        .then((res) => {
          const {
            eDescription,
            eOffice,
            eApprovedBy,
            // eSoftwareId,
            eRequestType,
            eContent,
            eTicketType,
            eFileContent,
            ePhoneNumber,
            eTrip,
            eWorkingTime,
            eFinishTime,
            eBaseOnDecision,
            eBaseOnProposal,
          } = res.fields;
          const approverEmail = eApprovedBy.split("|")[0];
          setValues({
            description: eDescription,
            requests: JSON.parse(eContent),
            fileRequests: JSON.parse(eFileContent),
            phoneNumber: ePhoneNumber,
            destinationBusiness: eOffice,
            tripItineraty: eTrip,
            startDate: eWorkingTime,
            endDate: eFinishTime,
            baseOnDecision: eBaseOnDecision,
            baseOnProposal: eBaseOnProposal ? JSON.parse(eBaseOnProposal) : [],
          });
          setApprover(approverEmail);
          // setSoftwareSelected(eSoftwareId);
          setContentData(JSON.parse(eContent));
          setRequestType(eRequestType);
          setStartDate(new Date(eWorkingTime));
          setEndDate(new Date(eFinishTime));
          setTicketType(eTicketType);
        })
        .catch((error) => console.log(error));
    } else {
      setApprover(employees[0]?.eMail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    getApproverOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment, selectedUnit]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureCollaborateTicket.path)}>
              <Icon.ArrowLeft />
            </div>
            {id === 0 ? "Tạo Đề Nghị Cấp/Hoàn Vé Công Tác" : "Chỉnh sửa Đề Nghị Cấp/Hoàn Vé Công Tác"}
          </div>
        </div>
        <Col>
          <form onSubmit={handleSubmit}>
            <Box title="Thông tin">
              <Row>
                <Col sm="12" md="12">
                  <InputWraper
                    className="pb-3"
                    inputProps={getInputProps("type")}
                    renderInput={(s) => (
                      <InputSelectTag
                        {...s}
                        options={ticketTypeRequest}
                        value={ticketType}
                        onChange={onTicketTypeChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              {ticketType === "refund" && (
                <Row>
                  <Col sm="12" md="12">
                    <InputWraper
                      className="pb-3"
                      inputProps={getInputProps("beforeRequest")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={businessTicketsMyRequests
                            .filter((e: any) => e.fields.eTicketType === "full" || e.fields.eTicketType === "ticket")
                            .map((o: any) => ({
                              id: o.id,
                              label: `Yêu cấp cấp vé công tác phiếu số ${o.id}`,
                              value: { ...o.fields },
                            }))
                            .sort((a, b) => b.id - a.id)}
                          value={beforeRequestSelected}
                          onChange={handleBeforeRequestChange}
                          placeholder="* Chọn yêu cầu đã cấp trước đó"
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}
              {id === 0 && (
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("deparment")}
                      isRequired
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={department.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedDepartment}
                          onChange={onDepartmentChange}
                          placeholder="* Chọn Cơ quan/ đơn vị"
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("unit")}
                      isRequired
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={unit.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedUnit?.value}
                          onChange={onUnitChange}
                          placeholder={"* Chọn đơn vị"}
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}
              <InputWraper
                inputProps={getInputProps("phoneNumber")}
                renderInput={(s) => <InputNumber {...s} />}
                isRequired
              />
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("startDate")}
                    renderInput={(s) => (
                      <>
                        <InputDateTimeAntd {...s} value={startDate} onChange={onStartDateChange} />
                      </>
                    )}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("endDate")}
                    renderInput={(s) => (
                      <>
                        <InputDateTimeAntd {...s} value={endDate} onChange={onEndDateChange} minDate={startDate} />
                      </>
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="6" md="6">
                  <InputWraper inputProps={getInputProps("baseOnDecision")} renderInput={(s) => <InputText {...s} />} />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper inputProps={getInputProps("baseOnProposal")} renderInput={(s) => <Upload {...s} />} />
                </Col>
              </Row>
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("destinationBusiness")}
                    renderInput={(s) => <InputText {...s} placeholder="VD: Đà Nẵng, Nội Bài" />}
                    isRequired={ticketType !== "refund"}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("tripItineraty")}
                    renderInput={(s) => <InputText {...s} placeholder="VD: SGN-HAN-SGN" />}
                    isRequired={ticketType !== "passport"}
                  />
                </Col>
              </Row>
              <InputWraper inputProps={getInputProps("description")} isRequired component={InputTextArea} />
            </Box>

            <Box title="Yêu cầu đặt chỗ">
              <InputWraper
                isRequired
                inputProps={getInputProps("requests")}
                renderInput={(state) => (
                  <InputArrayData
                    {...state}
                    // isKeepValue={true}
                    isTrip={true}
                    isOnlyPassport={ticketType === "passport"}
                    isRefund={ticketType === "refund"}
                    onChange={(e) => setContentData(e)}
                    value={contentData}
                    // isSelectUnit={selectedUnit ? 1 : 0}
                    form={BusinessTicketContentForm}
                    structure={BusinessTicketContentStructure}
                    excelTemplate="business-ticket"
                  />
                )}
              />

              <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

              {id === 0 && (
                <>
                  <Row>
                    <Col sm="6" md="6">
                      <InputWraper
                        inputProps={getInputProps("pickApprover")}
                        renderInput={(s) => (
                          <UserSelect
                            {...s}
                            placeholder="Thủ trưởng CQ/ĐV"
                            options={approverOptions}
                            value={approver}
                            onChange={onApproverChange}
                          />
                        )}
                        isRequired
                      />
                    </Col>
                    <Col sm="6" md="6">
                      <InputWraper
                        inputProps={getInputProps("findApprover")}
                        renderInput={(s) => (
                          <div className="people_picker-custom">
                            <PeoplePicker
                              className="people-picker"
                              placeholder="Thủ trưởng CQ/ĐV"
                              type={PersonType.any}
                              selectionChanged={onApproverPickerChange}
                            />
                          </div>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12">
                      <InputWraper
                        inputProps={getInputProps("pickItLead")}
                        renderInput={(s) => (
                          <UserSelect
                            {...s}
                            placeholder="Bộ phận hành chính VPCT"
                            options={eTicketOptions}
                            value={itLead}
                            onChange={onItLeadChange}
                          />
                        )}
                        isRequired
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Box>
            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="grey-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureCollaborateTicket.path)}
              />
            </div>
          </form>
        </Col>
      </div>
    </div>
  );
});
